import { ListingType, ListingCategory } from '../../classes/enums';
import { Pipe, PipeTransform } from '@angular/core';
import { CommunicationService } from '../../services/communication.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const RESIDENTIAL_GTM_PREFIX = 'residential';
export const COMMERCIAL_GTM_PREFIX = 'commerical';
export const LUXURY_GTM_PREFIX = 'collection';

export function transformAnalyticsTagForListingType(tagSuffix: string, type: ListingCategory) : string {
    let newTag = tagSuffix;
    switch (type) {
        case ListingCategory.RESIDENTIAL:
            newTag = RESIDENTIAL_GTM_PREFIX + newTag;
            break;
        case ListingCategory.LUXURY:
            newTag = LUXURY_GTM_PREFIX + newTag;
            break;
        case ListingCategory.COMMERCIAL:
            newTag = COMMERCIAL_GTM_PREFIX + newTag;
            break;
    }
    return newTag;
}

@Pipe({ name: 'listingTypeAnalyticsTag' })
export class ListingTypeAnalyticsTagPipe implements PipeTransform {

  constructor(private communicationService: CommunicationService) {

  }

  transform(tagSuffix: string): Observable<{ event: string }> {
    return this.communicationService.listings.currentShownListingType
        .pipe(map((type) => {

            if (!tagSuffix) {
                return { event: tagSuffix };
            }

            return { event: transformAnalyticsTagForListingType(tagSuffix, type) };
        }));
  }
}
